import { createRouter, createWebHistory } from 'vue-router'

import fuelManagementRouter from '@/router/modules/fuel-management'
import vehicleRouter from '@/router/modules/vehicle'
import trailerRouter from '@/router/modules/trailer'
import fleetAccessSettingsRouter from '@/router/modules/fleet-access-settings'
import GPSTrackingRouter from '@/router/modules/gps-tracking'
import driverRouter from '@/router/modules/driver'
import driverCareRouter from '@/router/modules/driver-care'
import userSettingsRouter from '@/router/modules/user-settings'
import notificationRouter from '@/router/modules/notification'
import reportRouter from '@/router/modules/report'
import advanceRouteRouter from '@/router/modules/advance-route'
import eventCalendarRouter from '@/router/modules/event-calendar'
// import checklistRouter from '@/router/modules/checklist'
import breakdownSupportRouter from '@/router/modules/breakdown-support'
// import smartAnalyticsRouter from '@/router/modules/smart-analytics'
import coldChainMonitoringRouter from '@/router/modules/cold-chain-monitoring'
import greenFleetDashboardRouter from './modules/green-fleet-dashboard'
// import insuranceRouter from '@/router/modules/insurance'
// import tollRouter from '@/router/modules/toll'
import safetyRouter from '@/router/modules/safety'
// import routeRouter from '@/router/modules/route'
import { getLite } from '@/utils/auth'
import KPIRouter from '@/router/modules/kpi-dashboard'
import iotConfiguratorRouter from '@/router/modules/iot-configurator'
import externalCarrierVisibilityRouter from '@/router/modules/external-carrier-visibility'
// import toolsRouter from './modules/tools'

export const constantRoutes = [
  {
    path: '/redirect',
    component: () => import('@/views/redirect/redirect'),
    name: 'Redirect',
    hidden: true
  },
  {
    path: '/login',
    component: () => import('@/views/Login/login'),
    name: 'LOGIN',
    meta: {
      bypass: true
    },
    hidden: true
  },
  {
    path: '/vehicle-certificate',
    name: 'VehicleCertificate',
    component: () => import('@/certificate/vehicle-certificate.vue'),
    hidden: true
  },
  {
    path: '/401',
    name: 'error-401',
    component: () => import('@/views/ErrorPage/401-Error.vue'),
    hidden: true
  },
  {
    path: '/403',
    name: 'error-403',
    component: () => import('@/views/ErrorPage/403-Error.vue'),
    hidden: true
  },
  {
    path: '/404',
    name: 'error-404',
    component: () => import('@/views/ErrorPage/404-Error.vue'),
    hidden: true
  },
  {
    path: '/500',
    name: 'error-500',
    component: () => import('@/views/ErrorPage/500-Error.vue'),
    hidden: true
  },
  {
    path: '/sharableLink/:id?',
    component: () => import('@/views/GPS-Tracking/VehicleTrackingList/public-vehicle-tracking.vue'),
    name: 'PublicVehicleTracking',
    meta: { title: 'PublicVehicleTracking', bypass: true },
    hidden: true
  },
  {
    path: '/sharableLiveVideoLink/:id?',
    component: () => import('@/views/GPS-Tracking/VehicleTrackingList/public-live-video.vue'),
    name: 'PublicLiveVideo',
    meta: { title: 'PublicLiveVideo', bypass: true },
    hidden: true
  },
  {
    path: '/safevision-intercom',
    component: () => import('@/views/mobile-iframe/sv-intercom.vue'),
    name: 'SVIntercom',
    meta: { title: 'SVIntercom', bypass: true },
    hidden: true
  },
  {
    path: '/video-player',
    component: () => import('@/views/mobile-iframe/video-player.vue'),
    name: 'VideoPlayer',
    meta: { title: 'VideoPlayer', bypass: true },
    hidden: true
  },
  // {
  //   path: '/testingGround',
  //   component: () => import('@/views/redirect/testing-ground.vue'),
  //   name: 'Testing',
  //   meta: { title: 'Testing'},
  //   hidden: true
  // },
  // {
  //   path: '/kpi-dashboard',
  //   component: () => import('@/views/KPIDashboard/kpi-dashboard'),
  //   name: 'KPIDashboard',
  //   meta: { title: 'KPIDashboard', icon: 'dashboard', parent: { title: 'KPIDashboard', icon: 'dashboard'} }
  // },
]

const PARTY = process.env.VUE_APP_PARTY
// export const asyncRoutes = [
//   userSettingsRouter,
//   notificationRouter,
//   // {
//   //   path: '/kpi-dashboard',
//   //   component: () => import('@/views/KPIDashboard/kpi-dashboard'),
//   //   name: 'KPIDashboard',
//   //   meta: { title: 'KPIDashboard', icon: 'dashboard', parent: { title: 'KPIDashboard', icon: 'dashboard'} }
//   // },
//   // KPIRouter,
//   // smartAnalyticsRouter,
//   ...(PARTY === 'AlamFlora' ? [] : [KPIRouter]),
//   ...(PARTY === 'AlamFlora' ? [] : [greenFleetDashboardRouter]),
//   eventCalendarRouter,
//   GPSTrackingRouter,
//   /*{ //add here first, will cause normal de login display so its bad
//     path: '/gps-tracking/full-map-tracking-lite/:id?',
//     component: () => import('@/views/GPS-Tracking/FullMapTracking/full-map-tracking-lite.vue'),
//     name: 'FullMapTrackingLitve',
//     meta: { title: 'FullMapTrackingLite', icon: 'GpsTracking'}
//   },
//   {
//     path: '/gps-tracking/vehicle-tracking-list',
//     component: () => import('@/views/GPS-Tracking/VehicleTrackingList/vehicle-tracking-list.vue'),
//     name: 'VehicleTrackingList',
//     meta: { title: 'VehicleTrackingList', icon: 'GpsTracking'}
//   },*/
//   vehicleRouter,
//   ...(PARTY === 'AlamFlora' ? [] : [trailerRouter]),
//   driverRouter,
//   safetyRouter,
//   ...(PARTY === 'AlamFlora' ? [] : [fuelManagementRouter]),
//   ...(PARTY === 'AlamFlora' ? [] : [coldChainMonitoringRouter]),
//   ...(PARTY === 'AlamFlora' ? [] : [driverCareRouter]),
//   // checklistRouter,
//   reportRouter,
//   ...(PARTY === 'AlamFlora' ? [] : [advanceRouteRouter]),
//   ...(PARTY === 'AlamFlora' ? [] : [breakdownSupportRouter]),
//   fleetAccessSettingsRouter,
//   // insuranceRouter,
//   // routeRouter,
//   // tollRouter,
//   ...(PARTY === 'AlamFlora' ? [] : [iotConfiguratorRouter]),

// ]

const modules = {
  userSettings:        userSettingsRouter,
  notification:        notificationRouter,
  kpiDashboard:        KPIRouter,
  greenFleetDashboard: greenFleetDashboardRouter,
  eventCalendar:       eventCalendarRouter,
  gpsTracking:         GPSTrackingRouter,
  vehicle:             vehicleRouter,
  trailer:             trailerRouter,
  driver:              driverRouter,
  safety:              safetyRouter,
  fuelManagement:      fuelManagementRouter,
  coldChainMonitoring: coldChainMonitoringRouter,
  driverCare:          driverCareRouter,
  // checklist:        checklistRouter,
  report:              reportRouter,
  advanceRoute:        advanceRouteRouter,
  breakdownSupport:    breakdownSupportRouter,
  fleetAccessSettings: fleetAccessSettingsRouter,
  // smartAnalytics:   smartAnalyticsRouter,
  // insurance:        insuranceRouter,
  // route:            routeRouter,
  // toll:             tollRouter,
  
  externalCarrier:     externalCarrierVisibilityRouter,
  iotConfigurator:     iotConfiguratorRouter
}

const HIDDEN_MODULES = {
  Strack: [],
  AlamFlora: [
    'kpiDashboard', 'greenFleetDashboard', 'trailer', 'fuelManagement',
    'coldChainMonitoring', 'driverCare', 'advanceRoute', 'breakdownSupport',
    'iotConfigurator'
  ],
  ROT: [
    'trailer', 'driver', 'advanceRoute', 'breakdownSupport',
    'iotConfigurator', 'fleetAccessSettings'
  ]
  // NextParty: [...]
}

export function getAsyncRoutes(party = PARTY) {
  // Undefined or unknown party: hide nothing, show all modules
  const hidden = HIDDEN_MODULES[party] ?? []

  return Object.entries(modules)
    .filter(([key]) => !hidden.includes(key))
    .map(([, route]) => route)
}

export const asyncRoutes = getAsyncRoutes()

export const liteRoutes = [
  {
    path: '/redirect',
    component: () => import('@/views/redirect/redirect'),
    name: 'Redirect',
    hidden: true
  },
  {
    path: '/login',
    component: () => import('@/views/Login/login'),
    name: 'LOGIN',
    meta: {
      bypass: true
    },
    hidden: true
  },
  {
    path: '/vehicle-filter',
    component: () => import('@/components/vehicle-filter'),
    name: 'VehicleFilter',
    hidden: true,
    meta: { title: 'VehicleFilter' }
  },
  {
    path: '/gps-tracking/full-map-tracking-lite',
    component: () => import('@/views/GPS-Tracking/FullMapTracking/full-map-tracking-lite.vue'),
    name: 'FullMapTrackingLite',
    meta: { title: 'FullMapTrackingLite', icon: 'GpsTracking' }
  },
  {
    path: '/gps-tracking/vehicle-summary',
    component: () => import('@/views/GPS-Tracking/FullMapTracking/vehicle-summary.vue'),
    name: 'VehicleSummary',
    meta: { title: 'VehicleSummary' },
    hidden: true
  },
  {
    path: '/gps-tracking/real-time-tracking-group',
    component: () => import('@/views/GPS-Tracking/RealTimeTrackingGroup/real-time-tracking-group.vue'),
    name: 'RealTimeTrackingGroup',
    meta: { title: 'RealTimeTrackingGroup', icon: 'RealTimeTrackingGroup' }
  },
  {
    path: '/gps-tracking/vehicle-tracking-list-lite',
    component: () => import('@/views/GPS-Tracking/VehicleTrackingList/vehicle-tracking-list-lite.vue'),
    name: 'VehicleTrackingListLite',
    meta: { title: 'VehicleTrackingListLite', icon: 'vehicle' }
  },
  {
    path: '/vehicle-certificate',
    name: 'VehicleCertificate',
    component: () => import('@/certificate/vehicle-certificate.vue'),
    hidden: true
  },
  {
    path: '/401',
    name: 'error-401',
    component: () => import('@/views/ErrorPage/401-Error.vue'),
    hidden: true
  },
  {
    path: '/403',
    name: 'error-403',
    component: () => import('@/views/ErrorPage/403-Error.vue'),
    hidden: true
  },
  {
    path: '/404',
    name: 'error-404',
    component: () => import('@/views/ErrorPage/404-Error.vue'),
    hidden: true
  },
  {
    path: '/500',
    name: 'error-500',
    component: () => import('@/views/ErrorPage/500-Error.vue'),
    hidden: true
  },
  {
    path: '/sharableLink/:id?',
    component: () => import('@/views/GPS-Tracking/VehicleTrackingList/public-vehicle-tracking.vue'),
    name: 'PublicVehicleTracking',
    meta: { title: 'PublicVehicleTracking', bypass: true },
    hidden: true
  },
  {
    path: '/sharableLiveVideoLink/:id?',
    component: () => import('@/views/GPS-Tracking/VehicleTrackingList/public-live-video.vue'),
    name: 'PublicLiveVideo',
    meta: { title: 'PublicLiveVideo', bypass: true },
    hidden: true
  },
]

const isLite = getLite()
const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BUILD_PATH),
  // history: createWebHistory(),
  routes: isLite ? liteRoutes : constantRoutes
})

// export function updateRoutes(isLite) {
//   const newRoutes = isLite ? liteRoutes : constantRoutes;

//   // Remove existing routes
//   router.getRoutes().forEach((route) => {
//     router.removeRoute(route.name);
//   });

//   // Add new routes
//   newRoutes.forEach((route) => {
//     router.addRoute(route);
//   });
// }
export async function updateRoutes(isLite) {
  const newRoutes = isLite ? liteRoutes : constantRoutes;

  // Remove existing routes
  router.getRoutes().forEach((route) => {
    if (route.name) {
      router.removeRoute(route.name);
    }
  });

  // Add new routes
  newRoutes.forEach((route) => {
    router.addRoute(route);
  });

  // Return a promise so calling code knows it's done
  return Promise.resolve()
}

export default router